module.exports = "<div class=\"stock\" ng-click=\"$ctrl.getStatus()\" ng-class=\"{ loading: $ctrl.statusLoader }\">\n\t<div class=\"status\">\n\t\t<ul>\n\t\t\t<li><i class=\"ion-record {{ $ctrl.webshop }}\"></i> {{ 'webshop' | translate | ucfirst }}</li>\n\t\t\t<li><i class=\"ion-record {{ $ctrl.store }}\"></i> {{ 'in_store' | translate | ucfirst }}</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"status-loader\">\n\t\t<ion-spinner icon=\"spiral\"></ion-spinner>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/stock/stock.html
// module id = 423
// module chunks = 0